import * as React from 'react'
import { useMappedState } from 'redux-react-hook'
import history from './utils/history'
import { Spinner } from './organisms/spinner'
const { useEffect, useCallback } = React
export default (Component: any): React.SFC => {
  return (props: any) => {
    const { auth, app } = useMappedState(
      useCallback(
        state => ({
          auth: state.auth,
          app: state.app,
        }),
        []
      )
    )

    useEffect(
      () => {
        if (!app.loading && !auth.isSigningIn) {
          history.push('/')
        }
      },
      [app.loading, auth.isSigningIn, auth.user]
    )

    if (!app.loading && auth.isSigningIn && auth.user) {
      return <Component {...props} />
    }
    return <Spinner />
  }
}



// WEBPACK FOOTER //
// ./src/components/require-auth.tsx